import { FC } from "react";
import style from "./MultiSelect.module.css";

interface MultiSelectProps {
  values: {
    id: string;
    name?: string;
    selected?: boolean;
    disabled?: boolean;
  }[];
  selectedItems: string[];
  onUpdate: (id: string, checked: boolean) => void;
  disabled?: boolean;
  title?: string;
}

const MultiSelect: FC<MultiSelectProps> = ({ values, selectedItems, onUpdate, title }: MultiSelectProps) => {
  return (
    <>
      {title && <div className={style.title}>{title}</div>}
      <div className={style.container}>
        {values.map((x) => {
          const isSelected = selectedItems.includes(x.id);
          return (
            <div
              key={x.id}
              className={`${style.element}  ${isSelected ? style.selected : ""} ${x.disabled ? style.disabled : ""}`}
              onClick={x.disabled ? undefined : () => onUpdate(x.id, !selectedItems.includes(x.id))}
            >
              {x.name ?? x.id}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default MultiSelect;
